/**
 * Color helpers for the design tokens — mirror of mobile utils/color.ts.
 *
 * Derive a translucent variant from a token instead of hand-writing
 * `rgba(15, 138, 99, 0.12)` next to `#0F8A63` (the two drift apart).
 * Works on the hex values the JS hooks return (useThemeColor /
 * useNutrientColors / useRiskColors), not on `var(--…)` strings — for CSS
 * variables use a Tailwind opacity modifier (`bg-risk-safe/10`) instead.
 */

/** `withAlpha('#0F8A63', 0.15)` -> `'rgba(15, 138, 99, 0.15)'`. Passes through non-hex input. */
export function withAlpha(color: string, alpha: number): string {
  if (!color.startsWith('#')) return color;

  const normalized = color.slice(1);
  const full =
    normalized.length === 3
      ? normalized
          .split('')
          .map((c) => c + c)
          .join('')
      : normalized.slice(0, 6);

  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);

  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return color;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
